import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GetData } from '../utils/api';
import './About.css';

const About = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setLoading(true);
      const data = await GetData('/settings');
      setSettings(data.settings);
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  const company = settings?.company || {};
  const stats = settings?.stats || {};

  return (
    <div className="about-page">
      <div className="container">
        {/* Hero */}
        <div className="about-hero">
          <h1>Sobre Nosotros</h1>
          <p className="about-subtitle">
            Somos más que una tienda online, somos tu aliado en cada compra
          </p>
        </div>

        {/* Historia */}
        <div className="about-section">
          <div className="about-content-grid">
            <div className="about-text">
              <h2>Nuestra Historia</h2>
              <p>{company.description || 'Tu tienda online de confianza.'}</p>
              <p>
                Fundada en {company.foundedYear || '2020'}, hemos crecido para convertirnos en
                una plataforma confiable que conecta a miles de clientes con los mejores productos del mercado.
              </p>
            </div>
            <div className="about-image">
              <div className="about-image-placeholder">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z" fill="currentColor"/>
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Misión y Visión */}
        <div className="about-values">
          <div className="value-card">
            <h3>Nuestra Misión</h3>
            <p>{company.mission || 'Proporcionar productos de calidad excepcional a precios competitivos.'}</p>
          </div>

          <div className="value-card">
            <h3>Nuestra Visión</h3>
            <p>{company.vision || 'Ser la plataforma de e-commerce líder en la región.'}</p>
          </div>

          <div className="value-card">
            <h3>Nuestros Valores</h3>
            <p>
              {company.values && company.values.length > 0
                ? company.values.map(v => v.title).join(', ')
                : 'Integridad, excelencia, innovación'}
            </p>
          </div>
        </div>

        {/* Por qué elegirnos */}
        <div className="about-section">
          <h2 className="section-title">¿Por Qué Elegirnos?</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h4>Calidad Garantizada</h4>
              <p>Todos nuestros productos son cuidadosamente seleccionados y verificados</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h4>Precios Competitivos</h4>
              <p>Ofrecemos los mejores precios del mercado sin comprometer la calidad</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h4>Envío Rápido</h4>
              <p>Entregas en tiempo récord con seguimiento en tiempo real</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h4>Soporte 24/7</h4>
              <p>Nuestro equipo siempre está disponible para ayudarte</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h4>Compra Segura</h4>
              <p>Tecnología de encriptación para proteger tus datos</p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">✓</div>
              <h4>Devolución Fácil</h4>
              <p>Política de devolución simple y sin complicaciones</p>
            </div>
          </div>
        </div>

        {/* Estadísticas */}
        <div className="about-stats">
          <div className="stat-box">
            <div className="stat-number">{stats.customers || '10,000+'}</div>
            <div className="stat-label">Clientes Satisfechos</div>
          </div>

          <div className="stat-box">
            <div className="stat-number">{stats.products || '500+'}</div>
            <div className="stat-label">Productos Disponibles</div>
          </div>

          <div className="stat-box">
            <div className="stat-number">{stats.orders || '50,000+'}</div>
            <div className="stat-label">Pedidos Completados</div>
          </div>

          <div className="stat-box">
            <div className="stat-number">{stats.satisfaction || '98%'}</div>
            <div className="stat-label">Satisfacción</div>
          </div>
        </div>


        {/* CTA */}
        <div className="about-cta">
          <h2>¿Listo para comenzar?</h2>
          <p>Explora nuestro catálogo y descubre productos increíbles</p>
          <Link to="/products" className="btn btn-primary btn-lg">
            Ver Productos
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;
